import { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import './index.scss'

import AppHeader from '../../components/Header'
import AppFooter from '../../components/Footer'

import NEWSCONFIG from '../../configs/news'

class News extends Component {

  state = {
    newsInfo: []
  }

  componentDidMount () {
    let newsInfo = JSON.parse(JSON.stringify(NEWSCONFIG.info)).slice(0, 4)
    for (let row = 0; row < newsInfo.length; row++) {
      let element = newsInfo[row]
      element.image = ''
      let obj = { en: '', cn: '' }
      for (let col = 0; col < element.content.length; col++) {
        const ele = element.content[col]
        if (ele.type === 'paragraph') {
          obj.en += ele.en
          obj.cn += ele.cn
        } else if (ele.type === 'image' && !element.image) {
          element.image = ele.src
        }
      }
      element.content = obj
    }
    this.setState({ newsInfo })

    document.getElementById('root').scrollTop = 0
  }

  render () {
    let { lang } = this.props
    let { newsInfo } = this.state
    let { title } = NEWSCONFIG
    return (
      <div className='app-page page-news'>
        <AppHeader />
        <div className='page-container'>
          <div className='news-title'>{title[lang]}</div>
          <div className='flex-justify'>
            <div className='max-width flex-justify'>
              <div className='news-list'>
                {
                  newsInfo.map((item, index) => {
                    return (
                      <div className='list-block' key={index}>
                        <div className='block-image box'>
                          <div className='box-content'>
                            <div className='image-content background-image' style={{ backgroundImage: `url(${item.image})` }}></div>
                          </div>
                        </div>
                        <div className='block-title two-line-ellipsis'>{item.title[lang] || item.title.cn}</div>
                        <div className='block-introduction two-line-ellipsis'>{(item.content[lang] || item.content.cn).slice(0, 200)}</div>
                        <div className='flex-align'>
                          <div className='block-time flex-one'>{item.time}</div>
                          <Link className='block-view flex-align-justify' to={{ pathname: '/news/detail', state: { id: index } }}>{lang === 'cn' ? '了解更多' : 'Learn More'}</Link>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
        <AppFooter />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang
  }
}

export default connect(mapStateToProps)(News)
